import { PortCollection, PortCollectionFeature } from 'types/Port';

export type RegionKey = PortCollection['code'];

/** A region is the more appropriate name for the port collection */
export type Region = PortCollection;

// TODO: Remove this in favor of be supplied regions
export const REGION_MAP: Record<RegionKey, Region> = {
  USLA: {
    code: 'USLA',
    name: 'Los Angeles / Long Beach',
    shortName: 'LA/LB',
    initials: 'LA',
    timeZone: 'America/Los_Angeles',
    features: [
      PortCollectionFeature.AppointmentScraping,
      PortCollectionFeature.LegacyTerminalScreenshots,
      PortCollectionFeature.StopTheClock,
      PortCollectionFeature.TrackAndTrace,
    ],
    perDiemArchiveMinDate: '2019-04-15T07:00:00.000Z',
    terminalScreenshotsMinDate: '2019-05-23T07:00:00.000Z',
    smartPerDiemMinDate: '2022-11-22T07:00:00.000Z',
    route: 'la',
    shifts: ['shift1', 'shift2'],
    geographicRegion: 'West Coast',
    erlForecastDays: 3,
  },
  USNY: {
    code: 'USNY',
    name: 'New York / New Jersey',
    shortName: 'NY/NJ',
    initials: 'NY',
    timeZone: 'America/New_York',
    features: [PortCollectionFeature.StopTheClock, PortCollectionFeature.TrackAndTrace],
    perDiemArchiveMinDate: '2022-08-17T04:00:00.000Z',
    terminalScreenshotsMinDate: '2022-08-17T04:00:00.000Z',
    smartPerDiemMinDate: null,
    route: 'ny',
    shifts: ['shift1'],
    geographicRegion: 'East Coast',
    erlForecastDays: 4,
  },
};

export const REGIONS: Region[] = [REGION_MAP.USLA, REGION_MAP.USNY];
